var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompassDrafting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 35L22.6976 14.374M35.5 21.5625C31.8353 25.7146 26.4735 28.3333 20.5 28.3333C14.5265 28.3333 9.16472 25.7146 5.5 21.5625M5.5 35L18.3024 14.374M20.5 6.66667C18.1988 6.66667 16.3333 8.53215 16.3333 10.8333C16.3333 12.3279 17.1202 13.6387 18.3024 14.374M20.5 6.66667C22.8012 6.66667 24.6667 8.53215 24.6667 10.8333C24.6667 12.3279 23.8798 13.6387 22.6976 14.374M20.5 6.66667V5M22.6976 14.374C22.0597 14.7708 21.3066 15 20.5 15C19.6934 15 18.9403 14.7708 18.3024 14.374",
    fill: "none",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassDrafting);
export default __webpack_public_path__ + "static/media/compass_drafting.f17e34d7fb693033fe4bc758c17b7ba5.svg";
export { ForwardRef as ReactComponent };